/*global VeloxWebView*/


var extension = {} ;
extension.name = "extraBrDosage-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "BROMINATOR_75"  : { FR: true, DE: true, ES: true, GB: false},
    "BROMINATOR_150" : { FR: true, DE: true, ES: true, GB: false},  
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).concat(["OTHER"]).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_extra_br_dosage."+p)
        } ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var dosageEl = view.viewRootEl.querySelector('[data-field-def="pool.p_extra_br_dosage"]');
        if(dosageEl){
            view.on("render", function(){
                var options = computeOptions();
                dosageEl.setOptions(options) ;
                if(options.length === 0){
                    dosageEl.style.display = "none" ;
                }else{
                    dosageEl.style.display = "block" ;
                }
            }) ;
        }   
    }) ;
} ;




module.exports = extension ;